import { render, staticRenderFns } from "./DoctorRegisterModal.vue?vue&type=template&id=6e3bd523&"
import script from "./DoctorRegisterModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports